import { MappableModel } from './mappable-model'

export class EligibilityStatusTag extends MappableModel {
  public color: string
  public value: string

  public constructor(data: any) {
    if (!data.color) data.color = 'success'
    super(data)
  }
}
